var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.steps),function(step,i,n){return _c('CalendarGuideStep',{key:i,attrs:{"header":_vm._f("formattedNumber")(n + 1),"label":step.title,"link":step.link,"image":step.image}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }